import {
  CloseCircleOutlined,
  CheckOutlined,
  DownOutlined,
  QuestionCircleOutlined,
  DoubleRightOutlined,
} from '@ant-design/icons'
import {
  Row,
  Col,
  Tooltip,
  Checkbox,
  Button,
  Space,
  Divider,
  Tag,
  Empty,
  message,
  Input,
  Popover,
} from 'antd'
import { SSkuCard, STitle } from 'shj-components'
import styles from '../index.module.less'
import { useEffect, useState } from 'react'
import _, { isArray, isEmpty } from 'lodash'
import { useUpdateEffect } from 'ahooks'
import { useNavigate, useParams } from 'react-router-dom'
import {
  DetailHouseInfoList,
  listProductSkuRelationSpuFormat,
  saveBudgetDtl,
} from '@/services/order'
import ModifyStandard from '../../components/modifyStandard'
import { getUser } from '@/common/utils.ts'
import { batchGetForAuth, batchSaveOrUpdateForAuth } from '@/services/cache'
import KitDetailDialogV3 from '../../components/KitDetailDialogV3'
import SkuDynamic from '../../components/SkuDynamic'
import CheckModal from '../CheckModal'

const { TextArea } = Input
type IProps = {
  selectMaterialObj: any // 选中的材料
  currentSearchParams: any // 当前参数
  setFullLoading: (v: boolean) => void
  setDeleteMaterialObj: (v: any) => void
}
export const RightConfigArea = (props: IProps) => {
  const { selectMaterialObj, currentSearchParams, setFullLoading, setDeleteMaterialObj } = props
  const [data, setData] = useState<any[]>([]) // 所有数据
  const params = useParams()
  const user = getUser()
  const navigate = useNavigate()
  const budgetId = params.budgetId //报价id
  const type = params.type //当前选材类型
  const cacheStr = `history_material_${user?.workNumber}_${budgetId}_${type}` //缓存key
  const refItemId = params.refItemId
  const [checkNumber, setCheckNumber] = useState<number>(0)
  const [spaceAllList, setSpaceAllList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  // 是否收起
  const [expanded, setExpanded] = useState(false)
  const [collapseSpaceDetail, setCollapseSpaceDetail] = useState<any[]>([])
  // 备注、预算量计算式
  const [spaceDetailList, setSpaceDetailList] = useState<any[]>([])
  // 套件选择
  const [kitSku, setKitSku] = useState<any>({})
  const [kitSpu, setKitSpu] = useState<any>({})
  const [activityInfo, setActivityInfo] = useState<any>({})
  const [openKitDialog, setOpenKitDialog] = useState(false)
  const [combinationInfoList, setCombinationInfoList] = useState<any[]>([])
  // 商品规格
  const [skuList, setSkuList] = useState<any>([]) // 当前产品的sku map信息
  const [modifyLoading, setModifyLoading] = useState<boolean>(false) // 修改规格loading
  const [currentIndex, setCurrentIndex] = useState<number>(0) // 当前修改规格数组索引
  const [currentModifyStandardArray, setCurrentModifyStandardArray] = useState<any>([]) // 当前修改规格数组
  const [modifyStandardOpen, setModifyStandardOpen] = useState(false) // 修改规格
  // 动态属性
  const [skuDynamicOpen, setSkuDynamicOpen] = useState(false) // 动态属性弹窗
  const [skuDynamicVoList, setSkuDynamicVoList] = useState<any>([]) // 报价属性表单数据
  const [openCheckModal, setOpenCheckModal] = useState(false);

  // 初始化时 获取缓存数据
  useEffect(() => {
    getAllSpace()
    getCacheHistory()
  }, [])
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }
  // 获取所有空间
  const getAllSpace = async () => {
    const cacheData = await batchGetForAuth({ data: [cacheStr] })
    const spaceCheckedAll =
      cacheData && cacheData.length ? cacheData[cacheStr]?.value.spaceAllList : []
    DetailHouseInfoList({
      params: {
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      const array: any = res
      if (!array.length) return
      array.forEach((item: any) => {
        //   // 添加属性
        item.checked = false
        if (spaceCheckedAll && spaceCheckedAll.length) {
          spaceCheckedAll.forEach(el => {
            if (el.id === item.id) {
              item.checked = el.checked
            }
          })
        }
      })

      setSpaceAllList(array)
    })
  }
  // 更新当前选择数据
  useUpdateEffect(() => {
    const array = _.cloneDeep(data)
    const obj = _.cloneDeep(selectMaterialObj)
    obj.spaceChecked =
      spaceAllList
        .filter(el => {
          if (el.checked && obj.budgetItemList?.find(elItem => elItem.id === el.id)) {
            return el.id
          }
        })
        .map(el => el.id) || []
    array.push(obj)
    array.forEach((item: any) => {
      // 处理减项通项
      if (type === 'SUB') {
        item.spaceChecked = item?.budgetItemList[0]?.id ? [item.budgetItemList[0].id] : []
      }
    })

    setData(array)
  }, [selectMaterialObj])
  // 更新加入选材数量
  useUpdateEffect(() => {
    console.log(data)
    let number = 0
    data.map(item => {
      if (item.checked) {
        number++
      }
    })
    setCheckNumber(number)
  }, [data])
  // 全局空间应用
  const onChangeSpaceAll = (e, item) => {
    const newData = _.cloneDeep(data)
    item.checked = e.target.checked
    // 全选，应用全局
    newData.map(elItem => {
      // 实现空间全部应用 全选和全不选 即 全选的 空间只影响 该空间的勾选与否  不影响其他单独配的空间
      if (e.target.checked) {
        if (elItem.budgetItemList?.find(el => el.id === item.id)) {
          elItem.spaceChecked.push(item.id)
          elItem.spaceChecked = Array.from(new Set(elItem.spaceChecked))
        }
      } else {
        elItem.spaceChecked = elItem.spaceChecked.filter(el => el !== item.id)
      }
    })
    setData(newData)
  }
  // 单个空间应用
  const onChangeSpace = (checkedValues: string[], index?: any) => {
    const newData = _.cloneDeep(data)
    newData[index].spaceChecked = checkedValues
    // 处理默认值
    checkedValues.forEach((id: string) => {
      let spaceItem = newData[index].budgetItemList.find(el => el.id === id)
      if (spaceItem.displayQtyFormular) {
        changeCalculate(id, spaceItem.displayQtyFormular, index)
      }
    })
    setData(newData)
  }

  // 产品全选
  const onCheckAll = e => {
    const newData = _.cloneDeep(data)
    newData.map(elItem => {
      elItem.checked = e.target.checked
    })
    const number = e.target.checked ? data.length : 0
    setCheckNumber(number)
    setData(newData)
  }
  const handleCacheData = data => {
    if (data && data.length) {
      data = data.map((item: any) => {
        return item?.map((el: any) => {
          return {
            ...el,
            calculateFunc: Number(el.calculateFunc),
          }
        })
      })
    }
    return data || []
  }
  // 获取缓存
  const getCacheHistory = async () => {
    const cacheData = await batchGetForAuth({ data: [cacheStr] })
    if (cacheData && cacheData[cacheStr]) {
      let spaceDetailList = handleCacheData(cacheData[cacheStr]?.value?.spaceDetailList)
      setData(cacheData[cacheStr]?.value?.data || [])
      setSpaceDetailList(spaceDetailList)
    }
  }
  // 设置缓存
  const setCacheHistory = () => {
    let cacheData = {
      spaceAllList: spaceAllList,
      spaceDetailList: spaceDetailList,
      data: data,
    }
    batchSaveOrUpdateForAuth({
      data: [
        {
          key: cacheStr,
          value: cacheData,
        },
      ],
    }).then(res => {
      message.success(res.message || '保存成功')
    })
  }
  // 保存草稿
  const saveSpaceData = () => {
    setCacheHistory()
  }
  // 移除选材
  const deleteSpace = (record, index) => {
    setDeleteMaterialObj(record)
    const spaceList = _.cloneDeep(spaceDetailList)
    const collapseList = _.cloneDeep(collapseSpaceDetail)
    if (spaceList[index]) {
      spaceList.splice(index, 1)
    }
    if (typeof collapseList[index] === 'boolean') {
      collapseList.splice(index, 1)
    }
    setSpaceDetailList(spaceList)
    setCollapseSpaceDetail(collapseList)
    const array = _.cloneDeep(data)
    array.splice(index, 1)
    if (array.length === 0) {
      const list = spaceAllList
      list.map(el => {
        el.checked = false
      })
      setSpaceAllList(list)
    }
    setData(array)
  }

  const checkData = () => {
    setOpenCheckModal(true)
  }

  // 提交数据  成功->删除缓存 跳转页面  失败->回显数据
  const submitData = () => {
    setLoading(true)
    setFullLoading(true)
    const submitData = postData(data)
    console.log(currentSearchParams, 'currentSearchParams')
    console.log(submitData, 'submitData')
    const unSubmitData = submitData.filter(el => !el.checked) // 未提交数据 需要回显
    const unSubmitSpaceDetailList: any = []
    const unSubmitCollapseList: any = []
    submitData.forEach((item: any, index: number) => {
      if (!item.checked) {
        unSubmitSpaceDetailList.push(spaceDetailList[index])
        unSubmitCollapseList.push(collapseSpaceDetail[index])
      }
    })
    saveBudgetDtl({
      data: submitData.filter(el => el.checked),
    })
      .then((res: any) => {
        console.log(res)
        if (res && res.length) {
          message.error('提交失败')
          let reviewData = res.concat(unSubmitData)
          console.log(reviewData, '提交失败回显数据')
          setData(reviewData)
        } else {
          message.success('提交成功')
          // 提交成功移除已提交物料 清除缓存
          setData(unSubmitData)
          setSpaceDetailList([...unSubmitSpaceDetailList])
          setCollapseSpaceDetail([...unSubmitCollapseList])
          // 清空缓存
          batchSaveOrUpdateForAuth({
            data: [
              {
                key: cacheStr,
                value: {},
              },
            ],
          })
          // 清除勾选状态
          const list = spaceAllList
          list.map(el => {
            el.checked = false
          })
          setSpaceAllList(list)
        }
      })
      .catch(() => {
        const chooseData = _.cloneDeep(data)
        const newChooseData = chooseData.map(item => ({
          ...item,
          errMessage: '',
        }))
        setData(newChooseData)
      })
      .finally(() => {
        setLoading(false)
        setFullLoading(false)
      })
  }
  // 数据处理
  const postData = data => {
    console.log(currentSearchParams, 'currentSearchParams')

    data.map((item: any, index: number) => {
      // // 缓存数据可能会自身携带
      item.quoteBudgetId = budgetId
      item.refItemId = refItemId // 当前项目id
      item.type = type // 为通项传值
      // item.addType = currentSearchParams.sourceType || null
      // 空间明细字段处理
      if (item.spaceChecked && item.spaceChecked.length) {
        const array: any = []
        item.spaceChecked.forEach((el: any) => {
          // 获取空间的信息
          // 存在只有空间没有预算量计算式的情况
          if (spaceDetailList && spaceDetailList.length) {
            const obj = spaceDetailList[index]?.find(item => item.elTag === el)
            array.push({
              itemId: obj ? obj.elTag : el, // 空间标识id,
              remark: obj ? obj.remark : '',
              budgetQtyValue:
                obj &&
                (obj.calculateFunc || obj.calculateFunc === 0) &&
                typeof obj.calculateFunc === 'number'
                  ? obj.calculateFunc
                  : '',
              budgetQtyFormular: obj ? obj.calculate : '',
              elTag: obj ? obj.elTag : '', // 空间标识id
            })
          } else {
            array.push({
              itemId: el, // 空间标识id,
              remark: '',
              budgetQtyValue: '',
              budgetQtyFormular: '',
              elTag: el, // 空间标识id
            })
          }
        })

        if (type === 'SUB') {
          array.forEach((el: any) => {
            el.reduceSourceBudgetDtlId = item.referenceId
          })
        }
        item.list = array
      }
      if (
        (type === 'ADD' && !item.budgetItemList?.length) ||
        (type === 'SUB' && !item.budgetItemList?.length) ||
        (type === 'PROJECT' && !item.budgetItemList?.length)
      ) {
        // 无空间信息 但有一条预算量计算式
        const array: any = []
        array.push({
          itemId: refItemId,
          remark: item.remark || '',
          budgetQtyValue: item.calculateFunc,
          budgetQtyFormular: item.calculate || '',
        })
        item.list = array
      }
      item.dynaOptions = item.dynaOptions ? item.dynaOptions : item.productSku?.argMap
      // 处理产品明细
      if (item.packDtlList?.length) {
        item.packDtlList = item.packDtlList.filter(el => el.selectSkuId)
      }
      // 每种类型特殊字段处理
      switch (item.type) {
        case 'ACTIVITY':
          item.activityId = item.activity?.id
          item.activityProductId = item.activityProduct?.id
          delete item.generalId
          break
        case 'UP_DOWN':
          // 升降级 需要传参通项Id
          // item.generalId = currentSearchParams.generalId // 通项id
          break
        case 'SUB':
          item.reduceSourceBudgetDtlId = item.referenceId
          item.generalId = item.generalItemManageId
          break
        case 'ADD':
          item.generalId = item.generalItemManageId
          break
        default:
          break
      }
    })
    console.log(data, 'data')
    return data
  }

  const postSpaceData = () => {
    data.map((item: any, index: number) => {
      // // 缓存数据可能会自身携带
      item.quoteBudgetId = budgetId
      item.refItemId = refItemId // 当前项目id
      item.type = type // 为通项传值
      // item.addType = currentSearchParams.sourceType || null
      // 空间明细字段处理
      if (item.spaceChecked && item.spaceChecked.length) {
        const array: any = []
        item.spaceChecked.forEach((el: any) => {
          // 获取空间的信息
          // 存在只有空间没有预算量计算式的情况
          if (spaceDetailList && spaceDetailList.length) {
            const obj = spaceDetailList[index]?.find(item => item.elTag === el)
            array.push({
              itemId: obj ? obj.elTag : el, // 空间标识id,
              remark: obj ? obj.remark : '',
              budgetQtyValue:
                obj && obj.calculateFunc && typeof obj.calculateFunc === 'number'
                  ? obj.calculateFunc
                  : '',
              budgetQtyFormular: obj ? obj.calculate : '',
              elTag: obj ? obj.elTag : '', // 空间标识id
            })
          } else {
            array.push({
              itemId: el, // 空间标识id,
              remark: '',
              budgetQtyValue: '',
              budgetQtyFormular: '',
              elTag: el, // 空间标识id
            })
          }
        })

        if (type === 'SUB') {
          array.forEach((el: any) => {
            el.reduceSourceBudgetDtlId = item.referenceId
          })
        }
        item.formatSpaceList = array
      }
      if (
        (type === 'ADD' && !item.budgetItemList?.length) ||
        (type === 'SUB' && !item.budgetItemList?.length) ||
        (type === 'PROJECT' && !item.budgetItemList?.length)
      ) {
        // 无空间信息 但有一条预算量计算式
        const array: any = []
        array.push({
          itemId: refItemId,
          remark: item.remark || '',
          budgetQtyValue: item.calculateFunc,
          budgetQtyFormular: item.calculate || '',
        })
        item.formatSpaceList = array
      }
    })
    console.log(data, 'data')
    return data
  }

  const handleKitDetail = async (record: any, index) => {
    setKitSku(record.productSku)
    setKitSpu(record.productSpu)
    console.log(record, 'record')
    setCurrentIndex(index)
    // 二次点开回显
    if (type === 'ACTIVITY') {
      setActivityInfo({
        activityId: record.activity?.id,
        activityProductId: record.activityProduct?.id,
      })
    }
    if (record.packDtlList?.length) {
      setCombinationInfoList(record.packDtlList)
    } else {
      setCombinationInfoList([])
    }
    setOpenKitDialog(true)
  }
  const closeKitDialog = (value: any) => {
    setOpenKitDialog(false)
  }
  const handleLongDesc = data => {
    // 子产品有且只有一个为来源物料 工艺说明为该子产品的sku的工艺说明
    let materialList = data?.filter(
      (item: any) => item?.product?.sourceType === 'MATERIAL' && item?.checked
    )
    if (materialList.length === 1) {
      let skuInfo = materialList[0]?.skuList?.find(
        (el: any) => el.id === materialList[0]?.selectSkuId
      )
      return skuInfo?.longDesc
    } else {
      return ''
    }
  }
  const confirmInfo = (combinationInfoDetail: any, combinationPrice) => {
    console.log(combinationInfoDetail)
    console.log(currentIndex)
    let longDesc = ''
    if (combinationInfoDetail && combinationInfoDetail.length) {
      longDesc = handleLongDesc(combinationInfoDetail)
    }
    const newData = _.cloneDeep(data)
    newData[currentIndex].packDtlList = combinationInfoDetail
    newData[currentIndex].productSkuSalePrice =
      combinationPrice || combinationPrice === 0
        ? combinationPrice
        : newData[currentIndex].productSkuSalePrice
    newData[currentIndex].longDesc = longDesc

    setData(newData)
  }
  // 修改产品规格
  const handleEditDynamicProperties = async (record: any, index?: any) => {
    console.log(record, index)
    setModifyStandardOpen(true)
    setModifyLoading(true)
    setCurrentIndex(index)
    let dynaOptions
    let resData
    try {
      resData = await listProductSkuRelationSpuFormat({
        data: {
          quoteBudgetId: budgetId,
          productSpuId: record.productSpuId,
          generalId:
            type === 'UP_DOWN' || type === 'GENERAL' ? currentSearchParams.generalId || null : null,
          priceCalcType: type === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
          activityProductId: record?.activityProduct?.id || null,
        },
      })
    } catch {
      setModifyLoading(false)
    }
    setModifyLoading(false)
    dynaOptions = record.dynaOptions
    setSkuList(resData.skuList)
    resData.specificationArgList?.map((item: any) => {
      if (!isEmpty(dynaOptions)) {
        item.argValId = dynaOptions[item.argCode].valueId
        item.argValName = dynaOptions[item.argCode].valueName
      }
      item.options = item?.values.map((ol: any) => {
        return {
          ...ol,
          argValId: ol.valueId,
          argValName: ol.valueName,
        }
      })
      return item
    })
    console.log(resData.specificationArgList, 'resData.specificationArgList')

    setCurrentModifyStandardArray(resData.specificationArgList || [])
  }
  const onSubmitModifyStandard = async value => {
    console.log(value, currentIndex)
    let selectObj = {}
    let dynaOptions: any = {}
    let newSkuObj: any = {}
    value.forEach((item: any) => {
      selectObj[item.argCode] = {
        argValId: item.argValId,
        argValName: item.argValName,
      }
    })
    // 确定sku
    skuList.forEach((item: any) => {
      let flag = true
      for (let key in selectObj) {
        if (item.argMap[key].valueId !== selectObj[key].argValId) {
          flag = false
        }
      }
      if (flag) {
        newSkuObj = item
      }
    })
    console.log(newSkuObj, '选中的sku信息')

    // 选材之后确定SKU码
    const newData = _.cloneDeep(data)
    console.log(newSkuObj, 'newSkuObj')

    newData[currentIndex].dynaOptions = newSkuObj.argMap
    newData[currentIndex].productSkuName = newSkuObj.skuName
    newData[currentIndex].productSkuSalePrice = newSkuObj.priceInfo?.customerPrice
    newData[currentIndex].productSkuId = newSkuObj.id
    newData[currentIndex].productSkuPrimaryImage = newSkuObj?.mainPicUrl
    newData[currentIndex].longDesc = newSkuObj?.longDesc
    newData[currentIndex].productSpuPrimaryImage =
      newSkuObj?.mainPicUrl || newData[currentIndex].productSpuPrimaryImage

    setData(newData)
  }
  // 修改动态属性
  const handleEditSkuDynamicVoList = (record: any, index?: any) => {
    setSkuDynamicOpen(true)
    // setModifyLoading(true)
    setCurrentIndex(index)
    setSkuDynamicVoList(record.skuDynamicVoList)
  }
  const onSubmitSkuDynamicVoList = async value => {
    const newData = _.cloneDeep(data)
    newData[currentIndex].materialDynaOptions = value
    setData(newData)
  }
  // 条件渲染 套件选择、动态属性
  const flagRender = (record, index) => {
    return (
      <>
        {
          <>
            <>
              {type !== 'SUB' && record.productSpu?.skuSize > 1 && (
                <Button
                  style={{ marginRight: '10px' }}
                  onClick={() => handleEditDynamicProperties(record, index)}
                >
                  选择规格
                </Button>
              )}
              {type !== 'SUB' && record.skuDynamicVoList?.length > 0 && (
                <Button
                  style={{ marginRight: '10px' }}
                  onClick={() => handleEditSkuDynamicVoList(record, index)}
                >
                  报价属性
                </Button>
              )}
              {record.productSpu?.combinationInfo?.length > 0 && (
                <Button
                  style={{ marginRight: '10px' }}
                  onClick={() => handleKitDetail(record, index)}
                >
                  产品明细
                </Button>
              )}
            </>
          </>
        }
      </>
    )
  }

  const collapseSpace = (index: number) => {
    const newList = _.cloneDeep(collapseSpaceDetail)
    newList[index] = true
    setCollapseSpaceDetail(newList)
  }

  const expandSpace = (index: number) => {
    const newList = _.cloneDeep(collapseSpaceDetail)
    newList[index] = false
    setCollapseSpaceDetail(newList)
  }

  const changeCalculate = (elTag: string, val: string, index: number) => {
    const list = _.cloneDeep(spaceDetailList) || []
    let funcRes: any = ''
    try {
      const func = new Function(`return ${val}`)
      funcRes = func()
    } catch (err) {
      funcRes = false
    }
    funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
    if (list[index]) {
      const obj = list[index]?.find(item => item.elTag === elTag)
      if (obj) {
        obj.calculate = val
        obj.calculateFunc = funcRes
      } else {
        list[index].push({
          elTag,
          calculate: val,
          calculateFunc: funcRes,
        })
      }
    } else {
      list[index] = [
        {
          elTag,
          calculate: val,
          calculateFunc: funcRes,
        },
      ]
    }
    setSpaceDetailList(list)
  }

  // 增项-预算量计算式计算
  const onChangeCalculateAdd = (index: number, val: string) => {
    if (val) {
      let funcRes: any = ''
      try {
        const func = new Function(`return ${val}`)
        funcRes = func()
      } catch (err) {
        funcRes = false
      }
      funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
      const newData = _.cloneDeep(data)
      newData[index].calculate = val
      newData[index].calculateFunc = funcRes
      setData(newData)
    }
  }

  const changeRemark = (elTag: string, val: string, index: number) => {
    const list = _.cloneDeep(spaceDetailList) || []
    if (list[index]) {
      const obj = list[index]?.find(item => item.elTag === elTag)
      if (obj) {
        obj.remark = val
      } else {
        list[index].push({
          elTag,
          remark: val,
        })
      }
    } else {
      list[index] = [
        {
          elTag,
          remark: val,
        },
      ]
    }
    setSpaceDetailList(list)
  }
  // 空间选择弹出层
  const spaceContent = (index: number) => {
    const spaceChange = (id: string, index: number, error: string) => {
      if (error) {
        return
      }
      let list: any = _.cloneDeep(data[index].spaceChecked)
      if (data[index].spaceChecked.includes(id)) {
        list = data[index].spaceChecked.filter(itemId => itemId !== id)
      } else {
        list.push(id)
      }
      onChangeSpace(list, index)
    }
    return (
      <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        {data?.[index].budgetItemList?.map((item: any, idx: number) => (
          <>
            <div
              onClick={() => {
                spaceChange(item.id, index, item.errMessage)
              }}
              key={idx}
              style={{
                display: 'flex',
                color: item.errMessage ? 'gray' : '#000',
                justifyContent: 'space-between',
                marginTop: '6px',
                marginBottom: '6px',
                paddingLeft: '8px',
                paddingRight: data[index].spaceChecked?.includes(item.id) ? '8px' : '30px',
                cursor: 'pointer',
                backgroundColor: data[index].spaceChecked?.includes(item.id)
                  ? 'rgb(229, 245, 243)'
                  : '#fff',
              }}
            >
              {item?.showName}
              {data[index].spaceChecked?.includes(item.id) && (
                <span style={{ marginLeft: '8px', color: 'rgb(19, 101, 91)' }}>
                  <CheckOutlined />
                </span>
              )}
            </div>
          </>
        ))}
      </div>
    )
  }

  const handlePrice = (item: any) => {
    let value =
      item.changeLevelCustomerPrice ??
      item.budgetDtlSkuSalePrice ??
      item.productSkuSalePrice ??
      item.saleCustPrice

    return value || value === 0 ? '￥' + value : ''
  }
  const showNationalTagRender = (item: any) => {
    if (item.packDtlList?.length > 0) {
      // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
      let proList = item.packDtlList
        ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
        ?.filter(item => item.required || (!item.required && item.checked))
      let allNational = false
      allNational = proList?.every((item: any) => {
        if (item.selectSkuId) {
          return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
        }
        return false
      })
      if (allNational) {
        return (
          <div className={tagsMap.NATIONAL_UPPLEMENT}>
            <Tooltip placement="topLeft" title={'国补'}>
              国补
            </Tooltip>
          </div>
        )
      }
    } else {
      let showTags = item?.productSpu?.skuList?.find(
        (sku: any) => sku.id === item.productSkuId
      )?.showTags
      if (showTags && isArray(showTags)) {
        return showTags?.map((tag: any) => {
          return (
            <div className={tagsMap[tag.tagCode]}>
              <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
            </div>
          )
        })
      } else {
        return <></>
      }
    }
  }
  return (
    <div className={styles.baseBox}>
      <div className={styles.toolHead}>
        <STitle title={'选材车'} />
        <div>
          <Tooltip placement="top" title="点击保存草稿，可缓存当前所选产品，下次打开，可继续编辑">
            <QuestionCircleOutlined className={styles.garyFontColor} />
          </Tooltip>
          <Button style={{ marginLeft: '10px' }} onClick={saveSpaceData}>
            保存草稿
          </Button>
        </div>
      </div>
      {data[0]?.budgetItemList && spaceAllList && spaceAllList.length > 0 && (
        <Row align="middle" justify="space-between" className={styles.topToolBar}>
          <Col span={20} style={{ height: !expanded ? '22px' : 'auto', overflow: 'hidden' }}>
            <span className={styles.garyFontColor} style={{ margin: '0px 10px 0 5px ' }}>
              空间全部应用
            </span>
            {spaceAllList.map(item => {
              return (
                <Checkbox
                  disabled={data.length === 0}
                  key={item.id}
                  checked={item.checked}
                  onChange={(e: any) => onChangeSpaceAll(e, item)}
                >
                  {item.showName} {item.description ? `【${item.description}】` : ''}
                </Checkbox>
              )
            })}
          </Col>
          <Col span={4} style={{ textAlign: 'right' }}>
            <Button type="link" size="small" onClick={() => setExpanded(!expanded)}>
              {expanded ? (
                <>
                  <span>全部收起</span>
                </>
              ) : (
                <>
                  <span>全部展开</span>
                </>
              )}
            </Button>
          </Col>
        </Row>
      )}
      {/* 单个空间选择 */}
      <Space
        direction="vertical"
        size="small"
        split={<Divider style={{ margin: '0px' }} />}
        style={{ width: '100%', height: 'calc(100% - 165px)', overflowY: 'scroll' }}
      >
        {data.map((item, index) => {
          return (
            <div style={{ padding: '10px 5px' }} key={item.id + index}>
              <Row>
                <Col span={1} style={{ display: 'flex' }}>
                  {/* 勾选框 */}
                  <Checkbox
                    disabled={item.errMessage}
                    checked={item.checked}
                    defaultChecked={item.checked}
                    onChange={e => {
                      item.checked = e.target.checked
                      setCheckNumber(data.filter(item => item.checked).length)
                    }}
                  ></Checkbox>
                </Col>
                <Col span={15}>
                  {/* 产品信息 */}
                  {/* 减项通项时只显示名字 */}
                  {item.onlyShowTitle && (
                    <div>
                      <div style={{ marginBottom: '10px' }}>{item.referenceName}</div>
                      {(item?.productSpu?.longDesc || item?.longDesc) && (
                        <p className={styles.skuCard_longDesc}>
                          <span>工艺说明：</span>
                          <Tooltip
                            title={item?.longDesc || item?.productSpu?.longDesc}
                            placement="topLeft"
                            overlayStyle={{ maxWidth: '600px' }}
                          >
                            <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                          </Tooltip>
                        </p>
                      )}
                      <div style={{ fontSize: '24px', color: 'rgba(235, 55, 35, 1)' }}>
                        {item.saleCustPrice || item.saleCustPrice === 0
                          ? '￥' + item.saleCustPrice
                          : ''}
                      </div>
                    </div>
                  )}
                  {!item.onlyShowTitle && (
                    <SSkuCard
                      width={'100%'}
                      url={item.productSkuPrimaryImage || item?.productSku?.mainPicUrl}
                      urlList={item?.productSku?.imageUrls}
                      desc={
                        <>
                          <p className={styles.skuCard_skuId}>
                            SKU: {item.productSkuId || item.referenceId}
                          </p>
                          {(item?.productSpu?.longDesc || item?.longDesc) && (
                            <p className={styles.skuCard_longDesc}>
                              <span>工艺说明：</span>
                              <Tooltip
                                title={item?.longDesc || item?.productSpu?.longDesc}
                                placement="topLeft"
                                overlayStyle={{ maxWidth: '600px' }}
                              >
                                <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                              </Tooltip>
                            </p>
                          )}
                        </>
                      }
                      operation={() => {
                        return <div className={styles.skuCard_price}>{handlePrice(item)}</div>
                      }}
                      title={
                        <div className={styles.skuCard_title}>
                          {showNationalTagRender(item)}
                          {item.productSkuName || item.referenceName}
                        </div>
                      }
                      imgFilter={
                        item?.errMessage ? (
                          <div dangerouslySetInnerHTML={{ __html: item?.errMessage }} />
                        ) : undefined
                      }
                      disabled={item.errMessage}
                    ></SSkuCard>
                  )}
                </Col>
                <Col span={8} style={{ textAlign: 'right' }}>
                  {/* 动态渲染 操作按钮 */}
                  {flagRender(item, index)}
                  <Button danger onClick={() => deleteSpace(item, index)}>
                    移除
                  </Button>
                </Col>
              </Row>
              <Row style={{ marginTop: '10px' }}>
                {data[index].budgetItemList && data[index].budgetItemList?.length !== 0 && (
                  <Col span={7} style={{ height: '24px' }}>
                    {/* 空间配置 */}
                    <Popover content={() => spaceContent(index)} placement={'bottom'}>
                      <Button
                        disabled={item.errMessage}
                        size="small"
                        type="link"
                        style={{ gap: 0 }}
                      >
                        应用空间（{data[index].spaceChecked?.length || 0}/
                        {data[index].budgetItemList?.length || 0}）
                        <DownOutlined />
                      </Button>
                    </Popover>
                  </Col>
                )}
                {data[index].spaceChecked && data[index].spaceChecked.length !== 0 && (
                  <>
                    {collapseSpaceDetail[index] ? (
                      <Col span={14}>
                        {/* 已选择空间 */}
                        {data[index].spaceChecked &&
                          data[index].spaceChecked.map((elTag, elTagIndex) => {
                            if (data[index].budgetItemList?.find(el => el.id == elTag)) {
                              return (
                                <Tag
                                  key={elTag}
                                  className={styles.garyFontColor}
                                  closeIcon={item.errMessage ? '' : <CloseCircleOutlined />}
                                  style={{ cursor: 'pointer' }}
                                  onClose={() => {
                                    const newData = _.cloneDeep(data)
                                    newData[index].spaceChecked = newData[
                                      index
                                    ].spaceChecked.filter(el => el != elTag)
                                    setData(newData)
                                  }}
                                >
                                  {data[index].budgetItemList?.find(el => el.id == elTag)?.showName}
                                </Tag>
                              )
                            }
                          })}
                      </Col>
                    ) : (
                      <>
                        <Col
                          style={{ height: '24px', display: 'flex', alignItems: 'center' }}
                          span={6}
                        >
                          预算量计算式
                        </Col>
                        <Col
                          style={{ height: '24px', display: 'flex', alignItems: 'center' }}
                          span={8}
                        >
                          备注
                        </Col>
                      </>
                    )}
                    {!collapseSpaceDetail[index] ? (
                      <Col
                        onClick={() => collapseSpace(index)}
                        flex={'space-between'}
                        style={{
                          height: '24px',
                          color: 'rgba(0, 100, 255, 1)',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        span={3}
                      >
                        收起
                        <DoubleRightOutlined
                          style={{ transform: 'rotate(-90deg)', marginLeft: 4 }}
                        />
                      </Col>
                    ) : (
                      <Col
                        onClick={() => expandSpace(index)}
                        flex={'space-between'}
                        style={{
                          height: '24px',
                          color: 'rgba(0, 100, 255, 1)',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          cursor: 'pointer',
                        }}
                        span={3}
                      >
                        展开
                        <DoubleRightOutlined
                          style={{ transform: 'rotate(90deg)', marginLeft: 4 }}
                        />
                      </Col>
                    )}
                  </>
                )}
              </Row>
              {/* 展开的内容 */}
              {!collapseSpaceDetail[index] &&
                data[index].spaceChecked &&
                data[index].spaceChecked.map((elTag, elTagIndex) => {
                  if (data[index].budgetItemList?.find(el => el.id == elTag)) {
                    return (
                      <Row style={{ marginTop: 10, marginBottom: 24 }}>
                        <Col
                          span={7}
                          style={{
                            lineHeight: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            wordBreak: 'break-all',
                          }}
                        >
                          <CloseCircleOutlined
                            style={{ marginLeft: 8, marginRight: 10 }}
                            onClick={() => {
                              const newData = _.cloneDeep(data)
                              newData[index].spaceChecked = newData[index].spaceChecked.filter(
                                el => el != elTag
                              )
                              setData(newData)
                            }}
                          />
                          {data[index].budgetItemList?.find(el => el.id == elTag)?.showName}
                        </Col>
                        {/**
                         * 预算量计算式
                         */}
                        <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                          <Input
                            disabled={
                              (!data[index].updateBudgetQtyFormularFlag && type === 'GENERAL') ||
                              item.errMessage
                            }
                            value={
                              spaceDetailList[index]?.find(el => el.elTag == elTag)?.calculate ||
                              // data[index].budgetItemList?.find(el => el.id == elTag)?.displayQtyFormular ||
                              ''
                            }
                            onChange={e => changeCalculate(elTag, e?.target?.value, index)}
                            style={{ width: '65%' }}
                          ></Input>
                          {typeof spaceDetailList[index]?.find(el => el.elTag == elTag)
                            ?.calculateFunc === 'number' ? (
                            <span style={{ marginLeft: 4 }}>
                              {spaceDetailList[index]?.find(el => el.elTag == elTag)?.calculateFunc}
                            </span>
                          ) : spaceDetailList[index]?.find(el => el.elTag == elTag)
                              ?.calculateFunc === false ? (
                            <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                          ) : null}
                        </Col>
                        {/**
                         * 备注
                         */}
                        <Col span={11} style={{ display: 'flex', alignItems: 'center' }}>
                          <TextArea
                            value={
                              spaceDetailList[index]?.find(el => el.elTag == elTag)?.remark || ''
                            }
                            onChange={e => changeRemark(elTag, e?.target?.value, index)}
                            placeholder="请输入备注"
                            autoSize={{ minRows: 1, maxRows: 3 }}
                            maxLength={255}
                            showCount
                            disabled={item.errMessage}
                          />
                        </Col>
                      </Row>
                    )
                  }
                })}
              {/* 新增增项 等没有空间也要显示预算量计算式 */}
              {!data[index].budgetItemList?.length && !data[index].spaceChecked?.length && (
                <>
                  <Row>
                    <Col style={{ height: '24px', display: 'flex', alignItems: 'center' }} span={6}>
                      预算量计算式
                    </Col>
                    <Col style={{ height: '24px', display: 'flex', alignItems: 'center' }} span={8}>
                      备注
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 10, marginBottom: 24 }}>
                    {/**
                     * 预算量计算式
                     */}
                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                      <Input
                        onChange={e => {
                          onChangeCalculateAdd(index, e.target.value)
                        }}
                        value={data[index]?.calculate || ''}
                        style={{ width: '65%' }}
                        disabled={item.errMessage}
                      ></Input>

                      <span style={{ marginLeft: 4 }}>
                        {item.calculateFunc === false ? (
                          <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                        ) : (
                          item.calculateFunc
                        )}
                      </span>
                    </Col>
                    {/**
                     * 备注
                     */}
                    <Col span={11} style={{ display: 'flex', alignItems: 'center' }}>
                      <TextArea
                        value={data[index]?.remark || ''}
                        onChange={e => {
                          const newData = _.cloneDeep(data)
                          newData[index].remark = e.target.value
                          setData(newData)
                        }}
                        placeholder="请输入备注"
                        autoSize={{ minRows: 1, maxRows: 3 }}
                        maxLength={255}
                        showCount
                        disabled={item.errMessage}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </div>
          )
        })}
      </Space>
      {/* 暂无数据占位 */}
      {data.length === 0 && (
        <div className={styles.emptyBox}>
          <Empty />
        </div>
      )}
      {/* 底部提交区域 */}
      <Row align={'middle'} justify={'space-between'} className={styles.bottomToolBar}>
        <Col span={8} style={{ display: 'flex', alignItems: 'baseline' }}>
          <Checkbox
            disabled={data.length === 0}
            onClick={e => onCheckAll(e)}
            checked={data?.length ? data.every(el => el.checked) : false}
          >
            全选
          </Checkbox>
          <span>已选 {checkNumber} 个</span>
        </Col>
        <Col span={16} style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              navigate(-1)
            }}
          >
            返回
          </Button>
          <Button
            loading={loading}
            type="primary"
            disabled={data.filter(item => item.checked).length === 0}
            onClick={checkData}
            style={{ marginLeft: '10px' }}
          >
            去选材车确认
          </Button>
          <Button
            loading={loading}
            type="primary"
            disabled={data.filter(item => item.checked).length === 0}
            onClick={submitData}
            style={{ marginLeft: '10px' }}
          >
            加入选材
          </Button>
        </Col>
      </Row>
      {/* 产品明细 */}
      {openKitDialog && (
        <KitDetailDialogV3
          kitSku={kitSku}
          setKitSku={setKitSku}
          productInfo={kitSpu}
          open={openKitDialog}
          closeDialog={closeKitDialog}
          confirmInfo={confirmInfo}
          combinationInfoList={combinationInfoList}
          activityInfo={activityInfo}
          generalId={currentSearchParams.generalId}
          checkType="RightConfigArea"
        />
      )}

      {/* 修改规格 */}
      <ModifyStandard
        open={modifyStandardOpen}
        onCancel={() => {
          setModifyStandardOpen(false)
        }}
        loading={modifyLoading}
        formList={currentModifyStandardArray}
        title="选择规格"
        onSubmit={onSubmitModifyStandard}
        skuList={skuList}
      ></ModifyStandard>
      {/* 动态属性 */}
      <SkuDynamic
        open={skuDynamicOpen}
        onCancel={() => {
          setSkuDynamicOpen(false)
        }}
        loading={false}
        formList={skuDynamicVoList}
        title="报价属性"
        onSubmit={onSubmitSkuDynamicVoList}
      ></SkuDynamic>
      {
        openCheckModal && <CheckModal
          open={openCheckModal}
          onClose={() => setOpenCheckModal(false)}
          data={data}
          setData={setData}
          postSpaceData={postSpaceData}
          onSubmit={submitData}
          checkNumber={checkNumber}
          onCheckAll={onCheckAll}
          loading={loading}
        />
      }
    </div>
  )
}
